var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "#3E4049"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrowUp_svg__a)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3.333a1.53 1.53 0 0 1 1.15.519l6.525 7.416a1.228 1.228 0 1 1-1.844 1.622L8.125 6.405a.166.166 0 0 0-.25 0l-5.706 6.486a1.23 1.23 0 1 1-1.844-1.622l6.523-7.414A1.54 1.54 0 0 1 8 3.333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowUp_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgArrowUp;